import { formatPriceByLanguage } from 'ggApp/utils/money';
import { CURRENCIES_ASSOCIATION } from 'ggApp/modules/store/constants';

export const calculateVoucherPreviewDiscount = (previewVoucher, cart, activeStore) => {
    if (previewVoucher?.discount?.type === 'AMOUNT') {
        const previewVoucherDiscount = previewVoucher.discount.amountOff;
        return `-${formatPriceByLanguage(
            previewVoucherDiscount,
            CURRENCIES_ASSOCIATION[activeStore.default_currency],
            activeStore.activeLanguage,
        )}`;
    }
    if (previewVoucher?.discount?.type === 'PERCENT') {
        const previewVoucherDiscount = (previewVoucher.discount.percentOff / 100) * cart.itemTotal;
        return `-${formatPriceByLanguage(
            previewVoucherDiscount,
            CURRENCIES_ASSOCIATION[activeStore.default_currency],
            activeStore.activeLanguage,
        )}`;
    }
    return null;
};
